import React from 'react';
import PropTypes from 'prop-types';
import MarketoForm from '../../../Form/MarketoForm/MarketoForm';

import './ResourceRegistration.scss';

export default class ResourceRegistration extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        formId: PropTypes.number.isRequired,
        contentElement: PropTypes.node.isRequired,
    };

    static defaultProps = {};

    render() {
        const { formId, contentElement } = this.props;

        return (
            <div className="component-Employer-Marketing-ResourceRegistration">
                {contentElement}
                <div className="marketo-form-container">
                    <MarketoForm formId={formId} isHidden={false} />
                </div>
            </div>
        );
    }
}
